export const resources = {
  af: { common: require("./i80n/af.json") },
  am: { common: require("./i80n/am.json") },
  ar: { common: require("./i80n/ar.json") },
  ba: { common: require("./i80n/ba.json") },
  bd: { common: require("./i80n/bd.json") },
  br: { common: require("./i80n/br.json") },
  cn: { common: require("./i80n/cn.json") },
  cz: { common: require("./i80n/cz.json") },
  de: { common: require("./i80n/de.json") },
  dk: { common: require("./i80n/dk.json") },
  ee: { common: require("./i80n/ee.json") },
  en: { common: require("./i80n/en.json") },
  es: { common: require("./i80n/es.json") },
  fi: { common: require("./i80n/fi.json") },
  fr: { common: require("./i80n/fr.json") },
  gr: { common: require("./i80n/gr.json") },
  hr: { common: require("./i80n/hr.json") },
  id: { common: require("./i80n/id.json") },
  il: { common: require("./i80n/il.json") },
  in_1: { common: require("./i80n/in_1.json") },
  in_2: { common: require("./i80n/in_2.json") },
  in_3: { common: require("./i80n/in_3.json") },
  in_4: { common: require("./i80n/in_4.json") },
  in_5: { common: require("./i80n/in_5.json") },
  in_6: { common: require("./i80n/in_6.json") },
  in_7: { common: require("./i80n/in_7.json") },
  ir: { common: require("./i80n/ir.json") },
  is: { common: require("./i80n/is.json") },
  it: { common: require("./i80n/it.json") },
  jp: { common: require("./i80n/jp.json") },
  ke: { common: require("./i80n/ke.json") },
  kh: { common: require("./i80n/kh.json") },
  kp: { common: require("./i80n/kp.json") },
  ku_1: { common: require("./i80n/ku_1.json") },
  ku_2: { common: require("./i80n/ku_2.json") },
  me: { common: require("./i80n/me.json") },
  mm: { common: require("./i80n/mm.json") },
  ng_1: { common: require("./i80n/ng_1.json") },
  ng_2: { common: require("./i80n/ng_2.json") },
  ng_3: { common: require("./i80n/ng_3.json") },
  ng_4: { common: require("./i80n/ng_4.json") },
  nl: { common: require("./i80n/nl.json") },
  no: { common: require("./i80n/no.json") },
  ph: { common: require("./i80n/ph.json") },
  pk: { common: require("./i80n/pk.json") },
  pl: { common: require("./i80n/pl.json") },
  pt: { common: require("./i80n/pt.json") },
  ro: { common: require("./i80n/ro.json") },
  rs: { common: require("./i80n/rs.json") },
  ru: { common: require("./i80n/ru.json") },
  se: { common: require("./i80n/se.json") },
  si: { common: require("./i80n/si.json") },
  sl: { common: require("./i80n/sl.json") },
  sn: { common: require("./i80n/sn.json") },
  th: { common: require("./i80n/th.json") },
  tm: { common: require("./i80n/tm.json") },
  tr: { common: require("./i80n/tr.json") },
  vn: { common: require("./i80n/vn.json") },
  za: { common: require("./i80n/za.json") },
  za_2: { common: require("./i80n/za_2.json") },
  za_3: { common: require("./i80n/za_3.json") },
  zw: { common: require("./i80n/zw.json") },
};

export const SUPPORTED_LANGUAGES = Object.keys(resources);

export const getNormalizedLanguageKey = (value) => {
  if (!value) {
    return "en";
  }

  if (SUPPORTED_LANGUAGES.includes(value)) {
    return value;
  }

  const lower = String(value).toLowerCase();

  const matched = SUPPORTED_LANGUAGES.find((lang) => {
    const langLower = lang.toLowerCase();
    return lower === langLower || lower.startsWith(langLower);
  });

  return matched || "en";
};

